import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, Skeleton, Typography, Tooltip } from "@mui/material";
import { Toast } from "primereact/toast";
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import { useSelector, useDispatch } from 'react-redux';
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import IconButton from '@mui/material/IconButton';
import { Menu as PrimeMenu } from 'primereact/menu';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import CustomAxios from '../utils/CustomAxios';
import { useGetSubCategories } from '../Components/globalFunctions';
import { updateEdit, updateSubCategoryDetails, updateModal } from '../Redux/sub-category-redux';


export function SubCategory_table() {

  const toast = useRef(null)
  const sub_category = useSelector(state => state.subcategory.subcategory)
  const category = useSelector(state => state.category.category)
  const [updatedcategory, setUpdatedCategory] = useState()
  const categoryLoading = useSelector(state => state.subcategory.loading);
  const search = useSelector(state => state.subcategory.searchSubCategory)
  const dispatch = useDispatch();
  const menuRefs = useRef([]);
  const getCategory = useGetSubCategories()


  useEffect(() => {
    const newcategory = sub_category.map(obj2 => {
      const match = category.find(obj1 => obj1.id === obj2.category_id)
      return { ...obj2, category_name: match ? match.category_name : "N/A" }
    })
    console.log(newcategory)
    setUpdatedCategory(newcategory)
  }, [category, sub_category])


  const handleOpen = (row) => {
    console.log(row)
    dispatch(updateEdit(true))
    dispatch(updateSubCategoryDetails(row));
    dispatch(updateModal(true))
  };

  const confirmDelete = (item) => {
    console.log(item)
    confirmDialog({
      message: (
        <Box sx={{ display: "flex", gap: "10px", flexDirection: "column" }}>
          <Box sx={{ display: "flex", gap: "5px", alignItems: "center" }}>
            {item.sub_category_image.map((img) => (<Box component='img' src={img} sx={{ width: "40px", height: "40px", borderRadius: "8px", marginRight: "10px" }}></Box>))}
            <Box >{item.subcategory_name}</Box>
          </Box>
          <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>Do you want to delete this Sub Category, There are some some products which are associated with this category. </Typography>
        </Box>
      ),
      header: 'Delete Confirmation',
      defaultFocus: 'reject',
      acceptClassName: 'p-button-danger',
      accept: () => accept(item.id),
    });
  }

  const accept = async (id) => {
    console.log(id)
    const response = await CustomAxios.delete(`sub_category_update/${id}/`, {

    }).then(res => {
      getCategory()
      toast.current.show({ severity: 'success', summary: 'Success', detail: 'Sub Category Deleted Successfully', life: 3000 });
    }).catch(err => { console.log(err) });
  }

  console.log(updatedcategory)

  return (
    <Box>
      <Toast ref={toast} />
      <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px" }}>Sub Category List</Typography>
      <ConfirmDialog />
      <TableContainer sx={{ height: "100%" }}>
        <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
          <TableHead style={{ backgroundColor: "background.upload" }}>
            <TableRow >
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">S No</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Sub Category Images</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Sub Category Name</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Parent Category</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {updatedcategory?.length > 0
              ? updatedcategory?.filter((item) => {
                console.log(item)
                if (!item.subcategory_name) return false; // Exclude items without a description
                return search !== ""
                  ? item?.subcategory_name.toLowerCase().includes(search.toLowerCase()) // Case-insensitive search match
                  : true;
              })
                .map((item, ind) => {
                  if (!menuRefs.current[ind]) {
                    menuRefs.current[ind] = React.createRef();
                  }
                  return (
                    <>
                      {
                        <TableRow key={1}>
                          <TableCell
                            sx={{
                              textAlign: "left",
                              textTransform: "capitalize",
                              backgroundColor: "white",
                            }}
                          >
                            {ind + 1}
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: "left",
                              textTransform: "capitalize",
                              backgroundColor: "white",
                            }}
                          >
                            {item?.sub_category_image?.map((img) => (
                              <Box
                                component="img"
                                src={img}
                                sx={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "8px",
                                  marginRight: "10px",
                                }}
                              ></Box>
                            ))}
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: "left",
                              textTransform: "capitalize",
                              backgroundColor: "white",
                            }}
                          >
                            {item.subcategory_name}
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: "left",
                              textTransform: "capitalize",
                              backgroundColor: "white",
                            }}
                          >
                            {item.category_name}
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: "left",
                              textTransform: "capitalize",
                              backgroundColor: "white",
                              display: "flex",
                              gap: "8px",
                              alignItems: "center",
                            }}
                          >
                            <PrimeMenu
                              model={[
                                {
                                  label: "Edit",
                                  command: () => handleOpen(item),
                                },
                                {
                                  label: "Delete",
                                  command: () => confirmDelete(item),
                                },
                              ]}
                              popup
                              ref={menuRefs.current[ind]} // Use the indexed ref
                              style={{ marginLeft: "", marginTop: "-10px" }}
                              className="custom-menu"
                            />
                            <Tooltip title="View inventory batches" arrow>
                              <IconButton
                                sx={{ textTransform: "none" }}
                                onClick={(event) =>
                                  menuRefs.current[ind]?.current?.toggle(event)
                                } // Use the indexed ref to toggle menu
                              >
                                <MoreHorizSharpIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      }
                    </>
                  );
                })
              : (
                <TableRow>
                  {categoryLoading ? (
                    <TableCell
                      sx={{
                        textAlign: "center",
                        textTransform: "capitalize",
                        backgroundColor: "white",
                        height: "200px",
                        fontWeight: "700",
                      }}
                      colSpan={12}
                    >
                      <Box>
                        <Box sx={{ width: "80%" }}>
                          <Skeleton
                            animation="wave"
                            sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }}
                          />
                          <Skeleton
                            animation="wave"
                            sx={{ background: "rgb(0 0 0 / 6%)" }}
                          />
                        </Box>
                        <Box sx={{ width: "80%" }}>
                          <Skeleton
                            animation="wave"
                            sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }}
                          />
                          <Skeleton
                            animation="wave"
                            sx={{ background: "rgb(0 0 0 / 6%)" }}
                          />
                        </Box>
                        <Box sx={{ width: "80%" }}>
                          <Skeleton
                            animation="wave"
                            sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }}
                          />
                          <Skeleton
                            animation="wave"
                            sx={{ background: "rgb(0 0 0 / 6%)" }}
                          />
                        </Box>
                      </Box>
                    </TableCell>
                  ) : (
                    <TableCell
                      sx={{
                        textAlign: "center",
                        textTransform: "capitalize",
                        backgroundColor: "white",
                        height: "200px",
                        fontWeight: "700",
                      }}
                      colSpan={7}
                    >
                      No Category Details Available
                    </TableCell>
                  )}
                </TableRow>
              )}
          </TableBody>

        </Table>
      </TableContainer>
    </Box>
  )
}

